import React from 'react'
import logo from '../assets/images/logos/logo.png'
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { NonAuthRoutes } from '../url';


const Footer = () => {
  const navigate = useNavigate();

  return (
   
    <footer>
 
    <div className="bg-[#B35804] mt-4">
      <div className="container m-auto px-6 text-gray-600 md:px-12 lg:px-20">
        <div className="grid grid-cols-8 gap-6 mt-24 md:gap-0">
          <div className="col-span-8 md:col-span-2 lg:col-span-3">
            <div
              className="flex items-center justify-between gap-6 py-6 md:block md:space-y-6 md:border-none md:py-0"
            >
              <img src={logo}alt="diakrino_logo" width="100" height="42" className="w-32 mt-20" />
              <div className="flex gap-6">
        
              <a href="https://web.facebook.com/profile.php?id=100068594724360&_rdc=1&_rdr" className="transition text-white"> <Icon icon="logos:facebook" color="#374151" width="24" height="24" /></a>
              <Icon icon="fontisto:email" color="#374151" width="24" height="24" />
              </div>
            </div>
          </div>
          <div className="col-span-8 md:col-span-6 lg:col-span-5 mt-20">
            <div className="grid grid-cols-2 gap-6 pb-16 sm:grid-cols-3 md:pl-16">
              <div>
                <h6 className="text-lg font-medium text-gray-800 dark:text-gray-200">Company</h6>
                <ul className="mt-4 list-inside space-y-4">
                  <li>
                    <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.About)}>About</button>

                  </li>
                  <li>
                    <a href="/" className="transition text-white">Services</a>
                  </li>
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.Contact)}>Contact</button>
                  </li>
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.Home)}>partners</button>
                  </li>
                </ul>
              </div>
              <div>
                <h6 className="text-lg font-medium text-gray-800 dark:text-gray-200">Services</h6>
                <ul className="mt-4 list-inside space-y-4">
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.GreenEnergy)}>OilAndGas</button>
                  </li>
                  <li>
                  <button className="transition text-white"  onClick={() => navigate(NonAuthRoutes.CyberSecurity)}>CyberSecurity</button>
                  </li>
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.GreenEnergy)}>GreenEnergy</button>
                  </li>
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.Contact)}>Consultancy</button>
                  </li>
                
                
                </ul>
              </div>
              <div>
                <h6 className="text-lg font-medium text-gray-800">Resources</h6>
                <ul className="mt-4 list-inside space-y-4">
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.Brochure)}>Brochures</button>
                  </li>
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.Home)}>Customers</button>
                  </li>
                  <li>
                    <a href="#" className="transition text-white">Enterprise</a>
                  </li>
                  <li>
                  <button className="transition text-white" onClick={() => navigate(NonAuthRoutes.Home)}>Projects</button>
                  </li>
                 
                 
                </ul>
              </div>
            </div>
            <div className="flex justify-between py-4 pb-8 md:pl-16">
              <span>&copy; Diakrino 2023 - <span id="year"></span> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
                                      
  )
}

export default Footer